import { createSlice } from "@reduxjs/toolkit";

// Which citation the user is currently viewing. Visi reports the click; the sources drawer and the
// width of the editor's Visi panel both read it, so it cannot live inside VisiContainer.
const initialState = {
  selectedCitationNumber: 0,
  selectedTurnRef: null,
  selectionCount: 0,
};

const citationsSlice = createSlice({
  name: "visiCitations",
  initialState,
  reducers: {
    setSelectedCitationNumber: (state, action) => {
      state.selectedCitationNumber = action.payload;
      state.selectedTurnRef = null;
      state.selectionCount += 1;
    },
    setSelectedCitation: (state, { payload }) => {
      state.selectedCitationNumber = payload.citationNumber;
      state.selectedTurnRef = payload.turnRef ?? null;
      state.selectionCount += 1;
    },
    clearSelectedCitation: (state) => {
      state.selectedCitationNumber = 0;
      state.selectedTurnRef = null;
    },
  },
});

export const {
  setSelectedCitationNumber,
  setSelectedCitation,
  clearSelectedCitation,
} = citationsSlice.actions;

export const selectSelectedCitationNumber = (state) =>
  state.visi.citations.selectedCitationNumber;

export const selectSelectedCitationTurnRef = (state) =>
  state.visi.citations.selectedTurnRef;

export const selectCitationSelectionCount = (state) =>
  state.visi.citations.selectionCount;

export default citationsSlice.reducer;
